import { render, staticRenderFns } from "./HomepageCourseCustom.vue?vue&type=template&id=5a075942&scoped=true"
import script from "./HomepageCourseCustom.vue?vue&type=script&lang=js"
export * from "./HomepageCourseCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a075942",
  null
  
)

export default component.exports